import React from 'react';

//styling
import '../../../../css/global/Spinner/Spinner.scss';

export enum SpinnerSize {
    EXTRA_SMALL = 'xs-spinner',
    SMALL = 'small-spinner',
    MEDIUM = 'medium-spinner',
    LARGE = 'large-spinner'
}

const Spinner = ({spinnerSize}:{spinnerSize: SpinnerSize}) => {

    return <div className={`spinner ${spinnerSize}`} data-testid="loading-spinner"><div /><div /><div /><div /><div /><div /><div /><div /><div /></div>
}

export default Spinner